const quantityFormatter = (value: number) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (!value) return formatter.format(0);

  return formatter.format(value);
};

export default quantityFormatter;
